/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerhandletaken2Inputs */

const en_organizerhandletaken2 = /** @type {(inputs: Organizerhandletaken2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This handle is already taken. Try another one.`)
};

const de_organizerhandletaken2 = /** @type {(inputs: Organizerhandletaken2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Kurzname ist schon vergeben. Probier einen anderen.`)
};

/**
* | output |
* | --- |
* | "This handle is already taken. Try another one." |
*
* @param {Organizerhandletaken2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerhandletaken2 = /** @type {((inputs?: Organizerhandletaken2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerhandletaken2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerhandletaken2(inputs)
	return de_organizerhandletaken2(inputs)
});
export { organizerhandletaken2 as "organizerHandleTaken" }